<template>
  <div>
    <div class="btn-group-hdr">
      <div class="btn-group btn-group-toggle">
        <button class="btn btn-secondary btn-sm" @click="cancel">Cancel</button>
        <button class="btn btn-primary btn-sm" @click="confirmSave">Save</button>
      </div>
    </div>
    <div class="title-hdr bg-dark p-2 text-white">
      <p class="mb-0">
        Assign Permissions for Role:
        <span class="badge bg-success">{{ role.role_name }}</span>
      </p>
    </div>

    <!-- Outer tabs: Countries -->
    <ul class="nav nav-tabs" id="countryTab" role="tablist">
      <li
        v-for="(brands, country, cIndex) in groupedPermissions"
        :key="country"
        class="nav-item"
        role="presentation"
      >
        <button
          class="nav-link"
          :class="{ active: activeCountryTab === cIndex }"
          :id="`country-tab-${cIndex}`"
          data-toggle="tab"
          :data-target="`#country-tabpane-${cIndex}`"
          type="button"
          role="tab"
          :aria-controls="`country-tabpane-${cIndex}`"
          :aria-selected="activeCountryTab === cIndex ? 'true' : 'false'"
          @click="onCountryTabClick(cIndex)"
        >
          {{ country }}
        </button>
      </li>
    </ul>

    <div class="tab-content mt-1" id="countryTabContent">
      <div
        v-for="(brands, country, cIndex) in groupedPermissions"
        :key="country"
        class="tab-pane fade"
        :class="{ show: activeCountryTab === cIndex, active: activeCountryTab === cIndex }"
        :id="`country-tabpane-${cIndex}`"
        role="tabpanel"
        :aria-labelledby="`country-tab-${cIndex}`"
      >
        <!-- Middle tabs: Brands -->
        <ul class="nav nav-tabs" id="brandTab" role="tablist">
          <li
            v-for="(projects, brand, bIndex) in brands"
            :key="brand"
            class="nav-item"
            role="presentation"
          >
            <button
              class="nav-link"
              :class="{ active: activeBrandTabs[cIndex] === bIndex }"
              :id="`brand-tab-${cIndex}-${bIndex}`"
              data-toggle="tab"
              :data-target="`#brand-tabpane-${cIndex}-${bIndex}`"
              type="button"
              role="tab"
              :aria-controls="`brand-tabpane-${cIndex}-${bIndex}`"
              :aria-selected="activeBrandTabs[cIndex] === bIndex ? 'true' : 'false'"
              @click="onBrandTabClick(cIndex, bIndex)"
            >
              {{ brand }}
            </button>
          </li>
        </ul>

        <div class="tab-content mt-1" id="brandTabContent">
          <div
            v-for="(projects, brand, bIndex) in brands"
            :key="brand"
            class="tab-pane fade"
            :class="{ show: activeBrandTabs[cIndex] === bIndex, active: activeBrandTabs[cIndex] === bIndex }"
            :id="`brand-tabpane-${cIndex}-${bIndex}`"
            role="tabpanel"
            :aria-labelledby="`brand-tab-${cIndex}-${bIndex}`"
          >
            <!-- Inner tabs: Projects -->
            <ul class="nav nav-tabs" id="projectTab" role="tablist">
              <li
                v-for="(perms, project, pIndex) in projects"
                :key="project"
                class="nav-item"
                role="presentation"
              >
                <button
                  class="nav-link"
                  :class="{ active: activeProjectTabs[`${cIndex}-${bIndex}`] === pIndex }"
                  :id="`project-tab-${cIndex}-${bIndex}-${pIndex}`"
                  data-toggle="tab"
                  :data-target="`#project-tabpane-${cIndex}-${bIndex}-${pIndex}`"
                  type="button"
                  role="tab"
                  :aria-controls="`project-tabpane-${cIndex}-${bIndex}-${pIndex}`"
                  :aria-selected="activeProjectTabs[`${cIndex}-${bIndex}`] === pIndex ? 'true' : 'false'"
                  @click="setActiveProjectTab(cIndex, bIndex, pIndex)"
                >
                  {{ project }}
                </button>
              </li>
            </ul>

            <div class="tab-content mt-1" id="projectTabContent">
              <div
                v-for="(perms, project, pIndex) in projects"
                :key="project"
                class="tab-pane fade"
                :class="{ show: activeProjectTabs[`${cIndex}-${bIndex}`] === pIndex, active: activeProjectTabs[`${cIndex}-${bIndex}`] === pIndex }"
                :id="`project-tabpane-${cIndex}-${bIndex}-${pIndex}`"
                role="tabpanel"
                :aria-labelledby="`project-tab-${cIndex}-${bIndex}-${pIndex}`"
              >
                <div class="ck-tbl-dynamix">
                  <table id="tbl-minmax" class="table table-bordered table-hover table-inline-edit">
                    <thead class="thead-dark">
                      <tr>
                        <th style="width: 40px; text-align: center;">
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :checked="areAllPermissionsSelected(sortedPermissions(perms))"
                              @change="toggleAllPermissions(sortedPermissions(perms), $event.target.checked)"
                              :id="`select-all-perms-${cIndex}-${bIndex}-${pIndex}`"
                            />
                            <label
                              class="custom-control-label h4"
                              :for="`select-all-perms-${cIndex}-${bIndex}-${pIndex}`"
                            ></label>
                          </div>
                        </th>
                        <th class="h5">Permission Name</th>
                        <th class="h5">Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="perm in sortedPermissions(perms)"
                        :key="perm.permission_id"
                        @click="toggleCheckbox(perm.permission_id)"
                        style="cursor: pointer;"
                      >
                        <td class="text-center" @click.stop>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              v-model="selectedPermissionIds"
                              :value="perm.permission_id"
                              :id="`perm-checkbox-${perm.permission_id}`"
                            />
                            <label
                              class="custom-control-label h4"
                              :for="`perm-checkbox-${perm.permission_id}`"
                            ></label>
                          </div>
                        </td>
                        <td>
                          <label class="mb-0 font-weight-bold h6">{{ perm.permission_name }}</label>
                        </td>
                        <td class="h6">{{ perm.description }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { baseUrl } from '../../../.env.js'  // Adjust path as needed

export default {
  name: 'AssignPermission',
  props: {
    role: {
      type: Object,
      required: true
    },
    permissions: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      allPermissions: [],
      selectedPermissionIds: [],
      activeCountryTab: 0,
      activeBrandTabs: {}, // track active brand tab per country index
      activeProjectTabs: {} // track active project tab per country-brand key
    }
  },
  computed: {
    groupedPermissions() {
      // Group allPermissions by country -> brand -> project_name
      const grouped = {}
      this.allPermissions.forEach(perm => {
        if (!grouped[perm.country]) {
          grouped[perm.country] = {}
        }
        if (!grouped[perm.country][perm.brand]) {
          grouped[perm.country][perm.brand] = {}
        }
        if (!grouped[perm.country][perm.brand][perm.project_name]) {
          grouped[perm.country][perm.brand][perm.project_name] = []
        }
        grouped[perm.country][perm.brand][perm.project_name].push(perm)
      })

      // Helper to sort keys with a priority first, then alphabetically
      function sortKeysWithPriority(keys, priority) {
        const prioritySet = new Set(priority)
        const priorityKeys = keys.filter(k => prioritySet.has(k))
        const otherKeys = keys.filter(k => !prioritySet.has(k)).sort()
        return [...priorityKeys, ...otherKeys]
      }

      // Sort countries: Singapore first
      const sortedCountries = sortKeysWithPriority(Object.keys(grouped), ['Singapore'])

      const sortedGrouped = {}

      sortedCountries.forEach(country => {
        const brands = grouped[country]
        // Sort brands: Charles & Keith first
        const sortedBrands = sortKeysWithPriority(Object.keys(brands), ['Charles & Keith'])

        sortedGrouped[country] = {}

        sortedBrands.forEach(brand => {
          const projects = brands[brand]
          // Sort projects: User Management first
          const sortedProjects = sortKeysWithPriority(Object.keys(projects), ['User Management'])

          sortedGrouped[country][brand] = {}

          sortedProjects.forEach(project => {
            sortedGrouped[country][brand][project] = projects[project]
          })
        })
      })

      return sortedGrouped
    },
    sortedPerms() {
      return []
    }
  },
  mounted() {
    this.fetchAllPermissions()
  },
  methods: {
    toggleAllPermissions(perms, checked) {
      const permIds = perms.map(p => p.permission_id)
      if (checked) {
        // Add all permission IDs that are not already selected
        this.selectedPermissionIds = Array.from(new Set([...this.selectedPermissionIds, ...permIds]))
      } else {
        // Remove all permission IDs from selectedPermissionIds
        this.selectedPermissionIds = this.selectedPermissionIds.filter(id => !permIds.includes(id))
      }
    },
    sortedPermissions(perms) {
      return perms.slice().sort((a, b) => {
        const nameA = a.permission_name.toLowerCase()
        const nameB = b.permission_name.toLowerCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })
    },
    areAllPermissionsSelected(perms) {
      return perms.every(perm => this.selectedPermissionIds.includes(perm.permission_id))
    },
    toggleCheckbox(permissionId) {
      const index = this.selectedPermissionIds.indexOf(permissionId)
      if (index === -1) {
        this.selectedPermissionIds.push(permissionId)
      } else {
        this.selectedPermissionIds.splice(index, 1)
      }
    },
    fetchAllPermissions() {
      axios.get('/user/roles/permissions')
        .then(res => {
          if (res.data && res.data.permissions) {
            this.allPermissions = res.data.permissions
            this.selectedPermissionIds = this.permissions.map(p => p.permission_id)

            // Initialize active tabs
            const countries = Object.keys(this.groupedPermissions)
            countries.forEach((country, cIndex) => {
              this.$set(this.activeBrandTabs, cIndex, 0)

              const brands = Object.keys(this.groupedPermissions[country])
              brands.forEach((brand, bIndex) => {
                // Use a combined key for country-brand to track project tabs
                const key = `${cIndex}-${bIndex}`
                this.$set(this.activeProjectTabs, key, 0)
              })
            })
          } else {
            this.allPermissions = []
          }
        })
        .catch(err => {
          console.error('Failed to fetch permissions:', err)
          this.allPermissions = []
        })
    },
    cancel() {
      this.$emit('cancel')
    },
    confirmSave() {
      console.log('confirmSave called')
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to save the permission changes?",
        type: 'warning',  // use 'type' instead of 'icon' in v8
        showCancelButton: true,
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        console.log('Swal result:', result)
        if (result.value) {  // in v8, result.value === true means confirmed
          console.log('User confirmed save')
          this.savePermissions()
        } else {
          console.log('User cancelled save')
        }
      })
    },
    savePermissions() {
      console.log('savePermissions called, emitting save event')
      this.$emit('save', {
        roleId: this.role.role_id,
        permissions: this.selectedPermissionIds
      })
    },
    setActiveProjectTab(cIndex, bIndex, pIndex) {
      const key = `${cIndex}-${bIndex}`
      this.$set(this.activeProjectTabs, key, pIndex)
    },
    onCountryTabClick(cIndex) {
      this.activeCountryTab = cIndex
      // Reset brand tab to 0 for this country if not set
      if (this.activeBrandTabs[cIndex] === undefined) {
        this.$set(this.activeBrandTabs, cIndex, 0)
      }
      // Reset project tab for first brand of this country
      const country = Object.keys(this.groupedPermissions)[cIndex]
      if (country) {
        const brands = Object.keys(this.groupedPermissions[country])
        if (brands.length > 0) {
          const key = `${cIndex}-0`
          if (this.activeProjectTabs[key] === undefined) {
            this.$set(this.activeProjectTabs, key, 0)
          }
        }
      }
    },
    onBrandTabClick(cIndex, bIndex) {
      this.$set(this.activeBrandTabs, cIndex, bIndex)
      // Reset project tab for this country-brand
      const key = `${cIndex}-${bIndex}`
      if (this.activeProjectTabs[key] === undefined) {
        this.$set(this.activeProjectTabs, key, 0)
      }
    }
  },
  watch: {
    permissions: {
      immediate: true,
      handler(newPermissions) {
        this.selectedPermissionIds = newPermissions.map(p => p.permission_id)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/users/AssignPermission.vue